import { render, staticRenderFns } from "./ShipmentPlanner.vue?vue&type=template&id=2bb92342&"
import script from "./ShipmentPlanner.vue?vue&type=script&lang=js&"
export * from "./ShipmentPlanner.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentPlanner.vue?vue&type=style&index=0&id=2bb92342&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports